// @flow
import * as React from 'react';
import styled from 'styled-components';
import { Button } from '../../Common/Button';
import TextBox from '../../Common/TextBox';
import TickBox from '../../Common/TickBox';

const ButtonContainer = styled.div`
  margin-top: 1rem;

  button:first-child {
    margin-right: 0.5rem;
  }
`;

const InputGroup = styled.div`
  margin-bottom: 0.5rem;
`;

const Label = styled.label`
  display: block;
`;

type Props = {
  oldPassword: string,
  newPassword: string,
  passwordConfirmation: string,
  showPassword: boolean,
  allowSubmit: boolean,
  onChange: SyntheticInputEvent<HTMLInputElement> => mixed,
  onChangeShowPassword: () => void,
  onCancel: () => void,
  onSubmit: (SyntheticEvent<HTMLButtonElement>) => mixed
};

const PasswordPolicy = React.memo<Props>((props: Props) => (
  <form onSubmit={props.onSubmit}>
    <InputGroup>
      <Label htmlFor="oldPassword">Old Password</Label>
      <TextBox
        autoFocus
        autoComplete="false"
        autoCapitalize="false"
        type={props.showPassword ? 'text' : 'password'}
        id="oldPassword"
        name="oldPassword"
        value={props.oldPassword}
        onChange={props.onChange}
      />
    </InputGroup>
    <InputGroup>
      <Label htmlFor="newPassword">New Password</Label>
      <TextBox
        autoComplete="false"
        type={props.showPassword ? 'text' : 'password'}
        id="newPassword"
        name="newPassword"
        value={props.newPassword}
        onChange={props.onChange}
      />
    </InputGroup>
    <InputGroup>
      <Label htmlFor="passwordConfirmation">Confirm New Password</Label>
      <TextBox
        autoComplete="false"
        type={props.showPassword ? 'text' : 'password'}
        id="passwordConfirmation"
        name="passwordConfirmation"
        value={props.passwordConfirmation}
        onChange={props.onChange}
      />
    </InputGroup>
    <small>
      <TickBox
        text="Show Passwords"
        textAlign="right"
        value={props.showPassword}
        onChange={props.onChangeShowPassword}
      />
    </small>
    <ButtonContainer>
      <Button type="button" kind="secondary" onClick={props.onCancel}>
        Cancel
      </Button>
      <Button type="submit" kind="primary" disabled={!props.allowSubmit}>
        Submit
      </Button>
    </ButtonContainer>
  </form>
));

export default PasswordPolicy;
